import { FormikTextField } from "../../forms/Formik"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import type { PrivatePersonDetailsFormValues } from "../billReceiverTypes"

import { DebtorNumberField } from "./DebtorNumberField"
import { DetailsAddressFormSection } from "./DetailsAddressFormSection"

type PrivatePersonProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function PrivatePersonForm({ isMerchantAdmin }: PrivatePersonProps) {
    return (
        <>
            <DebtorNumberField isMerchantAdmin={isMerchantAdmin} />
            <LocalizedStrict id="bill-receivers-form-label-name" attrs={{ label: true }}>
                <FormikTextField<PrivatePersonDetailsFormValues> name="name" label="Name(*)" fullWidth />
            </LocalizedStrict>
            <DetailsAddressFormSection />
            <LocalizedStrict id="bill-receivers-form-label-telephone" attrs={{ label: true }}>
                <FormikTextField<PrivatePersonDetailsFormValues> name="telephone" label="Telephone (*)" fullWidth />
            </LocalizedStrict>
        </>
    )
}
